import useSWR, { SWRResponse } from 'swr';
import { Lead } from '../../../providers/api/dtos/lead';
import { getLead } from '../../../providers/api/lead/leadProvider';

export const LEAD_RID = '/leads/';

export default function useLead(leadId?: string): SWRResponse<Lead, Error> {
  return useSWR(leadId ? [LEAD_RID, leadId] : null, () => getLead(leadId!));
}
